<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">{{title}}</div>
        <div class="setting-addel mr-l15">
          <el-button @click="onAddEventButtonClick"><i class="fas fa-plus"></i></el-button>
          <el-button @click="onDeleteButtonClick" :disabled="checkedRows.length == 0"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <el-button type="primary" @click="onSaveButtonClick" :disabled="!eventEditedFlag">저장</el-button>
        <el-button @click="onCancelButtonClick" :disabled="!eventEditedFlag">취소</el-button>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="loading" ref="rsctypeEventTemplateTable"
      :data="eventTemplateTableData" :columns="columns" :column-default="columnDefault"
      row-class-name="c-dblclick" :pagination="false" :show-search-tool="showSearchTool" :show-custom-header="true"
      @selection-change="changeCheckedRow" @cell-dblclick="onCellDbclick">
      <!-- <template slot-scope="scope" slot="switch-slot">
        <el-switch v-model="scope.row.defaultapplyFlag" active-value="1" inactive-value="0" @change="checkEditiedEventData"></el-switch>
      </template>
      <template slot-scope="scope" slot="checkbox-slot">
         <el-checkbox v-model="scope.row.troubleTicketApplyFlag" true-label="1" false-label="0" @change="checkEditiedEventData"></el-checkbox>
      </template> -->
    </el-table-wrapper>
    <w-common-event-popup ref="eventPopup" :managetype-list="managetypeList" :selected-node="selectedNode" @re-load="loadData"></w-common-event-popup>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { differenceWith, isNil, isEqual, cloneDeep, clone } from 'lodash';
import { columnDefault } from '@/constants/table';
import EventSettingsAPI from '@/api/settings/common/event-settings';
import WCommonEventPopup from '../popup/CommonEventPopup';

export default {
  name: 'WEventTemplateTable',
  components: {
    WCommonEventPopup,
  },
  props: {
    managetypeList: Array,
    selectedNode: Object,
  },
  data() {
    return {
      loading: false,
      showSearchTool: false,
      eventTemplateTableData: [],
      eventTemplateTableOriginData: [],
      eventEditedFlag: false,
      checkedRows: [],
      columnDefault,
      columns: [
        {
          type: 'selection',
        },
        {
          prop: 'rscName',
          label: '자원명',
          width: 200,
        },
        {
          prop: 'eventId',
          label: '이벤트 아이디',
          searchable: true,
          width: 150,
        },
        {
          prop: 'eventMessage',
          label: '이벤트 메시지',
        },
        {
          prop: 'eventJudgePriority',
          label: '판단 순위',
          width: 100,
        },
      ],
    };
  },
  computed: {
    title() {
      const title = '이벤트';
      return isNil(this.selectedNode) ? title : `[${this.selectedNode.label}] ${title}`;
    },
  },
  watch: {
    selectedNode: {
      handler(object) {
        if (!isNil(object)) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      this.loading = true;
      EventSettingsAPI.getRscEventList(this.selectedNode).then((response) => {
        if (response.data.success) {
          this.checkedRows = [];
          this.eventTemplateTableData = response.data.data;
          this.eventTemplateTableOriginData = cloneDeep(response.data.data);
          this.$nextTick(() => {
            this.checkEditiedEventData();
          });
        } else {
          this.failToLoad();
        }
      }).catch(() => {
        this.failToLoad();
      }).finally(() => {
        this.loading = false;
      });
    },
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트', false));
    },
    onAddEventButtonClick() {
      this.$refs.eventPopup.open(this.selectedNode);
    },
    onCellDbclick(row) {
      if (row.eventlevelId === 'NM') {
        return;
      }
      this.$refs.eventPopup.open(this.selectedNode, clone(row));
    },
    onSaveButtonClick() {
      const action = msgUtil.action.SAVE;
      const target = '이벤트';
      EventSettingsAPI.updateEventList(differenceWith(this.eventTemplateTableData, this.eventTemplateTableOriginData, isEqual)).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    onDeleteButtonClick() {
      const target = '이벤트';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        EventSettingsAPI.deleteEventList(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    onCancelButtonClick() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    checkEditiedEventData() {
      this.eventEditedFlag = !isEqual(this.eventTemplateTableData, this.eventTemplateTableOriginData);
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/components/EventTemplateTable.vue